import { render, staticRenderFns } from "./DriverCompare.vue?vue&type=template&id=3fd54a18&"
import script from "./DriverCompare.vue?vue&type=script&lang=js&"
export * from "./DriverCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports